<template>
<div class="price-t">
  <p v-if="type == 1">会员账号评估值参考价格表：</p>
  <p v-else>会员账号系统回收价格表：建议会员提交出售卖出更好的价格！</p>
  
    <table class="p-table">
      <tbody>
        <tr>
          <th><span class="red">电子等级</span></th>
          <th>参考价格</th>
          <th><span class="red">电子等级</span></th>
          <th>参考价格</th>
          <th><span class="red">真人等级</span></th>
          <th>参考价格</th>
        </tr>
        <tr><td>1级</td><td>35元</td><td>31级</td><td>133000元</td><td>1级</td><td>56元</td></tr>
        <tr><td>2级</td><td>70元</td><td>32级</td><td>145000元</td><td>2级</td><td>140元</td></tr>
        <tr><td>3级</td><td>161元</td><td>33级</td><td>170000元</td><td>3级</td><td>280元</td></tr>
        <tr><td>4级</td><td>385元</td><td>34级</td><td>195000元</td><td>4级</td><td>490元</td></tr>
        <tr><td>5级</td><td>770元</td><td>35级</td><td>220000元</td><td>5级</td><td>700元</td></tr>
        <tr><td>6级</td><td>1540元</td><td>36级</td><td>245000元</td><td>6级</td><td>1050元</td></tr>
        <tr><td>7级</td><td>2345元</td><td>37级</td><td>282000元</td><td>7级</td><td>1400元</td></tr>
        <tr><td>8级</td><td>3150元</td><td>38级</td><td>320000元</td><td>8级</td><td>1750元</td></tr>
        <tr><td>9级</td><td>4060元</td><td>39级</td><td>358000元</td><td>9级</td><td>2100元</td></tr>
        <tr><td>10级</td><td>4900元</td><td>40级</td><td>396000元</td><td>10级</td><td>2800元</td></tr>
        <tr><td>11级</td><td>7360元</td><td>41级</td><td>434000元</td><td>11级</td><td>4000元</td></tr>
        <tr><td>12级</td><td>9200元</td><td>42级</td><td>495000元</td><td>12级</td><td>5600元</td></tr>
        <tr><td>13级</td><td>11040元</td><td>43级</td><td>558000元</td><td>13级</td><td>7200元</td></tr>
        <tr><td>14级</td><td>12960元</td><td>44级</td><td>620000元</td><td>14级</td><td>8800元</td></tr>
        <tr><td>15级</td><td>14880元</td><td>45级</td><td>685000元</td><td>15级</td><td>10400元</td></tr>
        <tr><td>16级</td><td>16800元</td><td>46级</td><td>750000元</td><td>16级</td><td>12000元</td></tr>
        <tr><td>17级</td><td>20000元</td><td>47级</td><td>875000元</td><td>17级</td><td>14400元</td></tr>
        <tr><td>18级</td><td>23200元</td><td>48级</td><td>1000000元</td><td>18级</td><td>17600元</td></tr>
        <tr><td>19级</td><td>26400元</td><td>49级</td><td>1125000元</td><td>19级</td><td>20800元</td></tr>
        <tr><td>20级</td><td>29600元</td><td>50级</td><td>1250000元</td><td>20级</td><td>24000元</td></tr>
        <tr><td>21级</td><td>38700元</td><td></td><td></td><td>21级</td><td>31500元</td></tr>
        <tr><td>22级</td><td>44100元</td><td></td><td></td><td>22级</td><td>36000元</td></tr>
        <tr><td>23级</td><td>49500元</td><td></td><td></td><td>23级</td><td>40500元</td></tr>
        <tr><td>24级</td><td>54900元</td><td></td><td></td><td>24级</td><td>45000元</td></tr>
        <tr><td>25级</td><td>60300元</td><td></td><td></td><td>25级</td><td>54000元</td></tr>
        <tr><td>26级</td><td>65700元</td><td></td><td></td><td>26级</td><td>63000元</td></tr>
        <tr><td>27级</td><td>76500元</td><td></td><td></td><td>27级</td><td>90000元</td></tr>
        <tr><td>28级</td><td>87300元</td><td></td><td></td><td>28级</td><td>180000元</td></tr>
        <tr><td>29级</td><td>98100元</td><td></td><td></td><td>29级</td><td>450000元</td></tr>
        <tr><td>30级</td><td>121000元</td><td></td><td></td><td>30级</td><td>720000元</td></tr>
      </tbody>
    </table>
 
</div>
</template>

<script>
export default {
  name: 'pricetable',
  props: {
      type: {
        type: Number,
        default: 1
      }
  }
}
</script>

<style lang="stylus" scoped>
.price-t
  border 1px solid #dcdcdc
  padding 25px 40px
  color #626262
  font-size 14px
  line-height 22px
  .p-table
    margin-top 25px
    width 100%
    white-space nowrap
    border-collapse collapse
    border solid 1px #dcdcdc
    text-align center
    & th
      line-height 40px
      background-color #efefef
      white-space nowrap
      color #626262
      text-align center
      font-size 14px
      font-weight normal
      border-top solid 1px #dcdcdc
      border-right solid 1px #dcdcdc
      position relative
    & td
      white-space nowrap
      background-color #fff
      text-align center
      line-height 40px
      color #626262
      font-size 13px
      border-top solid 1px #dcdcdc
      border-right solid 1px #dcdcdc
      position relative
</style>




// WEBPACK FOOTER //
// priceTable.vue?2b92cbae